import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import RedFlagType from '../../entities/redFlagType';
import RedFlag from '../../entities/redFlag';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
import {deleteRedFlag, collectRedFlagDeleteImpact} from './redFlagDeps';
export function canDeleteRedFlagType(): boolean {
return canCascadeDelete();
}
export function collectRedFlagTypeDeleteImpact(redFlagType: RedFlagType, context: DeleteImpactContext): void {
const key = 'redFlagType:' + redFlagType.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
workingRows<RedFlag>('redFlag', findAll<RedFlag>('redFlags')).filter(redFlag => redFlag.status !== 'D' && redFlag.redFlagTypeId === redFlagType.id).forEach(redFlag => {
if (context.visited.has('redFlag:' + redFlag.id)) return;
addDeleteImpact(context, 'redFlag:' + redFlag.id, 'redFlags');
collectRedFlagDeleteImpact(redFlag, context);
});
}
export function deleteImpactRedFlagType(redFlagType: RedFlagType): DeleteImpact {
const context = deleteImpactContext();
collectRedFlagTypeDeleteImpact(redFlagType, context);
return deleteImpactCounts(context);
}
export function deleteRedFlagType(redFlagType: RedFlagType, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteRedFlagType()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectRedFlagTypeDeleteImpact(redFlagType, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || redFlagType.id};
}
const key = 'redFlagType:' + redFlagType.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<RedFlag>('redFlag', findAll<RedFlag>('redFlags')).filter(redFlag => redFlag.status !== 'D' && redFlag.redFlagTypeId === redFlagType.id).forEach(redFlag => {deleteRedFlag(redFlag, mergeId, cascade);});

const deleted = redFlagType.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.RedFlagTypeActions.removeRedFlagTypeQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceRedFlagType(redFlagType: RedFlagType, replaceWith: RedFlagType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = redFlagType.id;}
const _work = workingSet();




workingRows<RedFlag>('redFlag', findAll<RedFlag>('redFlags')).filter(redFlag => redFlag.status !== 'D' && redFlag.redFlagTypeId === redFlagType.id).forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
if (_redFlag.status === 'D') return;
_redFlag.redFlagTypeId = replaceWith.id;
_redFlag.status = 'U';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;
_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
});
return redFlagType;
}
